module.exports = __webpack_public_path__ + "static/assets/caf81ad11200e11533c58a57d635342d.png";